import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Filter, FilterType, optionValues, ValueType } from '../../models';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';

@Component({
  standalone: false,
  selector: 'sa-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
  providers:[
    provideMomentDateAdapter({
      parse: {
        dateInput: ['YYYY-MM-DD']
      },
      display: {
        dateInput: 'YYYY-MM-DD',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
      },
    }),
  ],
})
export class FilterComponent implements OnInit {
  @Input()
  filter: Filter;

  @Output() deleteFilterClicked = new EventEmitter<Filter>();
  @Output() onFilterUpdate = new EventEmitter<Filter>();

  FilterType = FilterType;
  ValueType = ValueType;
  filterTypes = Object.values(FilterType);

  selectorOptions = [];

  ngOnInit(): void {
    this.selectorOptions = optionValues[this.filter.type]?.values;
  }

  onChangeType(value: FilterType) {
    this.filter.type = value;

    // Only fire filter update if the filter did have a value before
    if(this.filter.value !== undefined) {
      this.filter.value = undefined;
      this.onFilterUpdate.next(this.filter);
    }

    this.filter.value = undefined;
    this.selectorOptions = optionValues[this.filter.type]?.values;
  }

  onChangeValue(value) {
    this.filter.value = value;
    this.onFilterUpdate.next(this.filter);
  }

  onChangeTextValue(rawValue: string) {
    const trimmed = (rawValue || '').trim();
    this.filter.value = trimmed === '' ? undefined : trimmed;
    this.onFilterUpdate.next(this.filter);
  }

  isTextFilter(): boolean {
    return optionValues[this.filter.type]?.type === ValueType.TEXT;
  }

  isDateFilter(): boolean {
    return optionValues[this.filter.type]?.type === ValueType.DATE;
  }

  comparerFn = (filter1:FilterType, filter2:FilterType ) => filter1 === filter2;
  comparerFn2 = (filter1:boolean, filter2:boolean ) => filter1 === filter2;
  comparerFn3 = (filter1:string, filter2:string ) => filter1 === filter2;

  displayTitleForValue(value) {
    if (this.isTextFilter()) {
      return value;
    }
    return this.selectorOptions?.find(selectorOption => selectorOption.value === value)?.title;
  }
}
